import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  getListHopDongDelete,
  updateDataSearch,
} from "../../../../actions/DanhSachHopDongDelete";

export const SearchBarMobile = ({}) => {
  const dispatch = useDispatch();

  const dataSearch = useSelector((state) => state.dataSearchHopDongDelete); //dataSearchTaiSan dinh nghia o rootreducer

  const updateState = (field, text) => {
    dispatch(
      updateDataSearch({
        ...dataSearch,
        [field]: text,
        pageIndex: 1,
      })
    );
  };

  const updateTextValue = (field) => (e) => {
    updateState(field, e.target.value);
  };

  const onSearch = () => {
    dispatch(getListHopDongDelete(dataSearch));
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      dispatch(
        updateDataSearch({
          ...dataSearch,
          pageIndex: 1,
        })
      );
      dispatch(getListHopDongDelete(dataSearch));
    }
  }; //sự kiện tìm kiếm enter
  return (
    <>
      <div className="repeater-default hide-table-main show-mobile-main hidden-des-main">
        <div data-repeater-list="car">
          <div data-repeater-item className="">
            <form className="search-full form row bg-search-form form-mobile-search">
              <div className="text-right left-search search-p mb-1 ">
                <div className="search-mobile-new">
                  <fieldset className="form-group position-relative mb-0">
                    <input
                      type="text"
                      className="form-control input-sm"
                      placeholder="Tên, SĐT, CCCD khách hàng ..."
                      value={dataSearch.NameCus}
                      onChange={updateTextValue("NameCus")}
                      onKeyDown={handleKeyDown}
                    />
                    <div className="form-control-position" onClick={onSearch}>
                      <i className="mdi mdi-magnify"></i>
                    </div>
                  </fieldset>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
